import { Component, inject, input } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { HighlightDataDirective } from 'src/app/features/help-faq/directives/highlight-data.directive';
import { FaqAdapter } from 'src/app/features/help-faq/services/faq.adapter';

export type SigningKind = 'Ron' | 'IPEN' | 'Hybrid';

export interface QaItem {
    question: string;
    answer: string;
}

@Component({
  selector: 'app-faq-qa-list',
  standalone: true,
  templateUrl: './faq-qa-list.component.html',
  styleUrls: [
    './faq-qa-list.component.scss',
    '../shared/qa-item.scss',
  ],
  imports: [
    CurrencyPipe,
    TranslatePipe,
    HighlightDataDirective,
  ],
})
export class FaqQaListComponent {
  showMissing = false;

  items = input<QaItem[]>([]);

  private readonly faq = inject(FaqAdapter);

  protected readonly disbursementDate = this.faq.formattedDisbursementDate;
  protected readonly firstPaymentDate = this.faq.formattedFirstPaymentDate;
  protected readonly interestRate = this.faq.formattedInterestRate;
  protected readonly monthlyPayment = this.faq.formatedMonthlyPayment;
  protected readonly prepaymentPenalty = this.faq.formattedPrepaymentPenalty;
  protected readonly borrowerNames = this.faq.borrowerNames;
  protected readonly participantNames = this.faq.participantNames;
  protected readonly participantsLoading = this.faq.participantsLoading;
  protected readonly hasData = this.faq.hasData;
  protected readonly payoffs = this.faq.payoffs;
  protected readonly cashToCloseFromLoanEstimate = this.faq.cashToCloseFromLoanEstimate;
  protected readonly cashToCloseFinalIsFromBorrower = this.faq.cashToCloseFinalIsFromBorrower;
  protected readonly displayFundingTransfer = this.faq.displayFundingTransfer;
  protected readonly hasNbthParticipants = this.faq.hasNbthParticipants;
  names: string[] = ['Participant One', 'Participant Two', 'Participant Three'];

}
